import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import ContactPageData from 'app/Models/Content/ContactPageData';
import PageWrapper from 'app/Components/Shared/PageWrapper';

export default class ContactPage extends Page<ContactPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;
    return (
      <PageWrapper props={this.props} desktopLayout='background'>
        <ContentArea data={mainContentArea} context={context} />
      </PageWrapper>
    );
  }
}
